import {createStyles} from '@material-ui/core/styles';
import type {Theme} from '@material-ui/core/styles/createTheme';

export default createStyles((theme: Theme) => ({
    root: {
        display: 'flex',
        minHeight: '100%',
    },
    content: {
        backgroundColor: theme.palette.background.paper,
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        width: '70%',
        paddingTop: theme.spacing(15),
        paddingBottom: theme.spacing(30),
    },
    render: {
        width: '100%',
    },
    toolbar: theme.mixins.toolbar,
}));
